import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/addresses')({
  component: AdminAddressesRoute,
});

function AdminAddressesRoute() {
  return <Outlet />;
}
